var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie',{attrs:{"height":_vm.height,"options":_vm.options,"width":_vm.width},on:{"animCreated":_vm.handleAnimation}})}
var staticRenderFns = []

export { render, staticRenderFns }